import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import cx from "classnames";
import Select from "react-select-new";

import Pagination from "../../components/Pagination";

class CoursesPassesOverview extends Component {
    constructor(props) {
        super(props);

        this.timeoutId = null;

        this.state = {
            courses: [],
            count: 0,
            limit: 0,
            offset: 0,
            statusDropdownOpen: false,
            filters: {
                id: "",
                reference: "",
                display_name: "",
                state: [],
                all_passes_printed: false,
                trainer: null
            },
            isToggled: false,
            trainerOptions: [],
            sort: "first_pass_requested"
        };

        this.dropdownRef = React.createRef();
        this.toggleRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
        this.getCourses(0);
        this.getFilterTrainers();
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target) && this.toggleRef.current && !this.toggleRef.current.contains(event.target)) {
            this.setState({ statusDropdownOpen: false });
        }
    };

    getCourses = async (newOffset) => {
        try {
            const response = await axios.get("/v1/certification-passes/", {
                params: {
                    offset: newOffset,
                    limit: this.state.limit || 20,
                    ordering: this.state.sort,
                    has_qualitymark: this.state.isToggled ? true : null,
                    ...{ ...this.state.filters, trainer: this.state.filters.trainer?.value, ordering: this.state.sort }
                }
            });

            this.setState({
                courses: response.data.results,
                count: response.data.count,
                limit: response.data.limit,
                offset: response.data.offset
            });
        } catch (error) {
            console.error(error);
        }
    };

    getFilterTrainers = async () => {
        try {
            const response = await axios.get("/v1/trainers/?fields=uuid,name&pagination=false");

            let trainerOptions = response.data.map((item) => ({
                value: item.uuid,
                name: item.name
            }));

            this.setState({ trainerOptions });
        } catch (error) {
            console.error(error);
        }
    };

    handleFilterChange = (e) => {
        const newFilters = { ...this.state.filters, [e.target.name]: e.target.value };

        this.setState({ filters: newFilters }, () => {
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }

            this.timeoutId = setTimeout(() => {
                this.getCourses(this.state.offset, this.state.filters);
            }, 600);
        });
    };

    handleAllPassesFilterChange = (val) => {
        const newFilters = { ...this.state.filters, all_passes_printed: val };

        this.setState({ filters: newFilters }, () => this.getCourses(0));
    };

    handleToggleClick = () => {
        this.setState(
            (prevState) => ({ isToggled: !prevState.isToggled }),
            () => this.getCourses(0)
        );
    };

    handleSortChange = () => {
        this.setState((prevState) => ({ sort: prevState.sort === "first_pass_requested" ? "-first_pass_requested" : "first_pass_requested" }));
    };

    handleStatusDropdownClick = (e) => {
        e.stopPropagation();
        this.setState((prevState) => ({ statusDropdownOpen: !prevState.statusDropdownOpen }));
    };

    render() {
        const { courses, count, limit, offset, statusDropdownOpen, filters, isToggled, trainerOptions, sort } = this.state;

        let activateItem = <i style={{ cursor: "pointer" }} className="fa fa-toggle-off" title="Activeren" onClick={this.handleToggleClick}></i>;
        if (isToggled) {
            activateItem = <i style={{ cursor: "pointer" }} className="fa fa-toggle-on" title="Deactiveren" onClick={this.handleToggleClick}></i>;
        }

        const dropDownActiveStyle = { background: "#cce6ff" };

        return (
            <div style={{ width: "1200px" }}>
                <div className="section-top">
                    <h1>Aangevraagde passen</h1>
                </div>

                <div className="row">
                    <div className="col-3">
                        <p>Toon alleen cursussen van keurmerkopleiders</p>
                    </div>
                    <div className="col-9">
                        <div className="header-account-menu__icon has_qualitymark_toggle">{activateItem}</div>
                    </div>
                </div>

                <table className="table table-hover table-clickable">
                    <thead>
                        <tr>
                            <th>
                                <div>ID</div>
                                <input style={{ width: "65px" }} className="text-filter" name="id" value={filters.id} onChange={this.handleFilterChange} />
                            </th>
                            <th>
                                <div>Cursusnaam</div>
                                <input
                                    style={{ width: "165px" }}
                                    className="text-filter"
                                    name="display_name"
                                    value={filters.display_name}
                                    onChange={this.handleFilterChange}
                                />
                            </th>
                            <th style={{ width: "120px" }}>Einddatum</th>
                            <th style={{ width: "350px" }}>
                                Opleider( relatienummer)
                                <i
                                    onClick={() => {
                                        this.setState({ sort: this.state.sort === "trainer" ? "-trainer" : "trainer" }, () => this.getCourses(0));
                                    }}
                                    style={{ cursor: "pointer" }}
                                    className={`fa ${sort === "trainer" ? "fa-angle-up" : "fa-angle-down"}`}
                                />
                                <Select
                                    name="trainer"
                                    value={filters.trainer}
                                    className=""
                                    onChange={(e) => this.setState({ filters: { ...filters, trainer: e } }, () => this.getCourses(0))}
                                    controlShouldRenderValue={true}
                                    options={trainerOptions}
                                    getOptionLabel={(o) => o.name}
                                    getOptionValue={(o) => o.value}
                                    isClearable={true}
                                    backspaceRemovesValue={true}
                                    placeholder="Naam van de opleider"
                                    noOptionsMessage={() => "Geen resultaten"}
                                />
                            </th>
                            <th style={{ width: "65px" }}>Keurkmerk</th>
                            <th style={{ width: "65px" }}>Aantal passen</th>
                            <th style={{ width: "180px" }}>
                                Aanvraagdatum
                                <i
                                    onClick={() => {
                                        this.setState({ sort: this.state.sort === "first_pass_requested" ? "-first_pass_requested" : "first_pass_requested" }, () =>
                                            this.getCourses(0)
                                        );
                                    }}
                                    style={{ cursor: "pointer" }}
                                    className={`fa ${sort === "first_pass_requested" ? "fa-angle-up" : "fa-angle-down"}`}
                                />
                            </th>
                            <th>
                                <div
                                    ref={this.toggleRef}
                                    className="dropdown-filter-toggle__counter allPassesPrintedHeader"
                                    style={{ padding: "12px", cursor: "pointer", backgroundColor: "initial" }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.setState({ statusDropdownOpen: !statusDropdownOpen });
                                    }}
                                >
                                    Alle passen afgedrukt
                                    <i className="fa fa-angle-down" style={{ fontSize: "18px", fontWeight: "bold" }} />
                                </div>
                                <div
                                    ref={this.dropdownRef}
                                    style={{ top: "initial", right: "initial", padding: 0 }}
                                    className={cx("dropdown-filter", { "dropdown-filter--open": statusDropdownOpen })}
                                >
                                    <div
                                        onClick={() => this.handleAllPassesFilterChange(filters.all_passes_printed === true ? "" : true)}
                                        style={{
                                            cursor: "pointer",
                                            padding: "5px",
                                            marginBottom: "10px",
                                            ...(filters.all_passes_printed === true ? dropDownActiveStyle : {})
                                        }}
                                    >
                                        <i className="fa fa-check" style={{ color: "green", fontSize: "20px" }} />
                                    </div>
                                    <div
                                        onClick={() => this.handleAllPassesFilterChange(filters.all_passes_printed === false ? "" : false)}
                                        style={{ cursor: "pointer", padding: "5px", ...(filters.all_passes_printed === false ? dropDownActiveStyle : {}) }}
                                    >
                                        <i className="fa fa-times" style={{ color: "red", fontSize: "20px" }} />
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {courses.map((course) => {
                            return (
                                <tr
                                    key={course.uuid}
                                    onClick={() => {
                                        window.open("/passes/" + course.uuid, "_blank");
                                    }}
                                >
                                    <td>{course.id}</td>
                                    <td>{course.display_name}</td>
                                    <td style={{ width: "120px" }}>{moment(course.end_datetime).format("DD-MM-YYYY")}</td>
                                    <td style={{ width: "350px" }}>
                                        {course.trainer.name} ({course.trainer.eol_relation_code})
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        {course.trainer.has_qualitymark ? (
                                            <i className="fa fa-check" style={{ color: "green" }} />
                                        ) : (
                                            <i className="fa fa-times" style={{ color: "red" }} />
                                        )}
                                    </td>
                                    <td style={{ textAlign: "center" }}>{course.total_pass_count}</td>
                                    <td style={{ textAlign: "center" }}>{moment(course.first_pass_requested).format("DD-MM-YYYY")}</td>
                                    <td style={{ textAlign: "center" }}>
                                        {course.all_passes_printed ? (
                                            <i className="fa fa-check" style={{ color: "green" }} />
                                        ) : (
                                            <i className="fa fa-times" title={`${course.printed_pass_count}/${course.total_pass_count}`} style={{ color: "red" }} />
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                <Pagination count={count} limit={limit} offset={offset} pageSwitch={(i) => this.getCourses(i)} />
            </div>
        );
    }
}

export default CoursesPassesOverview;
